"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function _default() {
  return _react.default.createElement("svg", {
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    version: "1.1",
    style: {
      marginRight: 8
    }
  }, _react.default.createElement("title", null, "631DA144-A2A9-4469-B409-A03101CD9250@3x"), _react.default.createElement("desc", null, "Created with sketchtool."), _react.default.createElement("defs", null, _react.default.createElement("polygon", {
    id: "path-1",
    points: "0.000128887383 0.340421053 22.836641 0.340421053 22.836641 21.9998371 0.000128887383 21.9998371"
  })), _react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Reactive-Maps-Redesign-Page",
    transform: "translate(-163.000000, -495.000000)"
  }, _react.default.createElement("g", {
    id: "GITHUB",
    transform: "translate(151.000000, 484.000000)"
  }, _react.default.createElement("g", {
    id: "Github",
    transform: "translate(12.000000, 11.000000)"
  }, _react.default.createElement("g", {
    id: "Group-3"
  }, _react.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, _react.default.createElement("use", {
    xlinkHref: "#path-1"
  })), _react.default.createElement("g", {
    id: "Clip-2"
  }), _react.default.createElement("path", {
    d: "M14.416459,21.8880316 C13.9670744,20.6102947 14.531459,18.5729789 14.0915103,17.2634 C13.9546897,16.8535053 13.6851769,16.6549263 13.5501256,16.3069789 C16.8155359,16.1825053 18.7935359,14.1023474 18.6932795,10.7803474 C18.6549462,9.50666316 18.1931769,8.64345263 17.5019974,7.91108421 C17.8800231,7.09997895 17.7384846,5.66013684 17.3952538,4.93471579 C15.9427154,4.9434 15.1654333,5.61613684 14.2000231,6.10361053 C12.6796641,5.60282105 10.1478949,5.60745263 8.62517692,6.10361053 C7.67333077,5.62076842 6.89958718,4.96308421 5.48479231,4.93471579 C5.05192051,5.54955789 4.95048462,7.08550526 5.32261282,7.85782105 C4.69040769,8.62318947 4.21212564,9.40997895 4.13192051,10.6217158 C3.89897179,14.0635579 6.03207436,16.0921895 9.16538205,16.3602421 C9.2296641,16.6230842 8.56384359,17.1696105 8.62517692,17.8487158 C7.91335641,18.1405053 6.95915128,18.2221368 6.35112564,17.9546632 C5.17045897,17.4370842 4.85376667,15.2996105 3.04915128,15.8820316 C3.22961282,16.5067158 3.83586923,16.5802421 4.2386641,17.1041895 C4.61786923,17.5945579 4.70515128,18.2655579 5.10617692,18.6991895 C5.81563846,19.4697684 7.08358718,19.6509789 8.57092051,19.3904526 C8.38986923,20.1812947 8.9035359,21.6194 8.35448462,21.9412947 C7.96407436,22.1694 6.96622821,21.6755579 6.40538205,21.4092421 C4.68333077,20.5906105 3.20425385,19.2694526 2.23707436,18.0085053 C0.782176923,16.1118737 -0.289976923,13.4203474 0.0703564103,10.1961895 C0.385869231,7.40045263 1.74758718,5.08292632 3.48202308,3.50066316 C5.30551026,1.83734737 7.53768974,0.562505263 10.6810231,0.364505263 C14.0962282,0.149715789 16.7848692,1.37245263 18.6932795,2.96861053 C20.6535872,4.60703158 22.1303051,6.72134737 22.6451513,9.55761053 C23.7119974,15.4460842 20.1446385,19.6243474 16.3655615,21.4092421 C15.8135615,21.6697684 15.1418436,22.1462421 14.416459,21.8880316",
    id: "Fill-1",
    fill: "#30373C",
    mask: "url(#mask-2)"
  })), _react.default.createElement("path", {
    d: "M5.551,17.36167 C5.305,17.46067 5.028,17.43167 5,17.08767 C5.209,16.88667 5.572,17.05367 5.551,17.36167",
    id: "Fill-4",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M5.08737384,17 C5.36637384,17.057 5.55837384,17.203 5.54837384,17.55 C5.07537384,17.693 4.86837384,17.266 5.08737384,17",
    id: "Fill-6",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M6.09336271,17.0004512 C6.52936271,16.9854512 6.68336271,17.3474512 6.55236271,17.6444512 C6.07936271,17.7624512 5.86136271,17.3004512 6.09336271,17.0004512",
    id: "Fill-8",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M6.01430155,18.0136145 C6.56330155,17.9226145 6.81730155,18.3046145 6.65730155,18.6586145 C6.15330155,18.7306145 5.94030155,18.5146145 6.01430155,18.0136145",
    id: "Fill-10",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M6.828,18.4625006 C6.613,18.6485006 6.123,18.5585006 6,18.3725006 L6,18.0975006 C6.308,17.8785006 6.871,18.0405006 6.828,18.4625006",
    id: "Fill-12",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M7.83778894,18.1010445 C7.90378894,18.6040445 7.33378894,18.6100445 7.01378894,18.4690445 C6.89678894,17.9730445 7.55478894,17.9070445 7.83778894,18.1010445",
    id: "Fill-14",
    fill: "#30373C"
  }), _react.default.createElement("path", {
    d: "M7.75047793,18.0042024 C7.73647793,18.1102024 7.77147793,18.1662024 7.84447793,18.1862024 C7.83047793,18.5142024 7.53947793,18.5562024 7.20147793,18.5552024 C7.16047793,18.3782024 6.93847793,18.3882024 7.01647793,18.0962024 C7.15047793,17.9532024 7.48647793,18.0152024 7.75047793,18.0042024",
    id: "Fill-16",
    fill: "#30373C"
  }))))));
};
exports.default = _default;